export const AGENT_COLLECTED_DATA: Record<string, Record<string, string>> = {
  'post-agent': { intent: 'create_post' },
  'project-autofill': { intent: 'project_autofill' }
}
